import RouterProvider from './router/RouterProvider';
import QueryProvider from './query/QueryProvider';
import QueryDevtools from './query/QueryDevtools';
import AuthIdentitySync from '@/modules/auth/components/AuthIdentitySync';
import { Toaster } from 'react-hot-toast';

const Entry = () => {
  return (
    <QueryProvider>
      <AuthIdentitySync />
      <RouterProvider />
      <Toaster />
      <QueryDevtools />
    </QueryProvider>
  );
};

export default Entry;
